import { makeStyles } from "@material-ui/core/styles";

const useCouponRankingListPageStyles = makeStyles(
  theme => ({
    backButton: {
      "&:hover": {
        color: theme.palette.primary.main
      },
      alignItems: "center",
      color: theme.palette.text.primary,
      cursor: "pointer",
      display: "flex",
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(4),
      textDecoration: "none"
    },
    headerContainer: {
      alignItems: "center",
      display: "flex",
      justifyContent: "flex-start",
      width: "100%"
    }
  }),
  { name: "CouponRankingList" }
);

export default useCouponRankingListPageStyles;
